
export default {
        props: ['document', 'name']

    data: ->
        fields: @defaultFields()

    computed:
        isRequired: -> @fields.presence is 'erforderlich'
        type: -> 
            switch @fields.type
                when 'Text' then 'text'
                when 'E-Mail' then 'email'
                when 'Telefon' then 'tel'
                when 'Nummer' then 'number'
                when 'Datum' then 'date'
        placeholder: -> @$prismic.richTextAsPlain @fields.placeholder

    methods:
        defaultFields: ->
            id: []
            label: []
            placeholder: []
            presence: 'erforderlich'
            type: 'Text'
            function: 'keine'
            description: []
            options: []
    
        setContent: (document) ->
            fields =
                id: document.primary.id
                label: document.primary.label
                placeholder: document.primary.placeholder
                presence: document.primary.presence
                type: document.primary.type
                function: document.primary.function
                description: document.primary.description
                options: document.items
            $.extend @fields, fields

    created: ->
        @setContent @document
}
